import { Journey } from '@/models';
import { GenericService } from '../generic.service';

export class PatientJourneyService extends GenericService<Journey> {
  constructor(patientId: string) {
    super();
    this.endpoint = `/menicon/v1/patients/${patientId}/journeys`;
  }
}
